import { render } from "./VideoPlayerControlsSettingsReportIssue.vue?vue&type=template&id=0b986863"
import script from "./VideoPlayerControlsSettingsReportIssue.vue?vue&type=script&lang=js"
export * from "./VideoPlayerControlsSettingsReportIssue.vue?vue&type=script&lang=js"

import exportComponent from "/Users/tpere/RocketBears/vue-viewer-plugin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__